import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

// --- COMPONENTS ---
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute'; 
import Layout from './components/Layout';

// --- PAGES ---
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import SendMessage from './pages/SendMessage';
import ChatInterface from './pages/ChatInterface'; // This is your AI conversations view
import WhatsAppInbox from './components/WhatsAppInbox'; // <-- NEW: Live WhatsApp Inbox
import Wallet from './pages/Wallet';
import CampaignCreator from './pages/CampaignCreator';
import Settings from './pages/Settings';
import ReceiptPage from './pages/ReceiptPage';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          
          {/* --- GUEST ROUTES --- */}
          {/* PublicRoute auto-redirects authenticated users to their dashboard */}
          <Route element={<PublicRoute />}>
            <Route path="/" element={<LandingPage />} /> 
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>
          
          {/* --- PROTECTED USER ROUTES --- */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/send" element={<SendMessage />} />
              <Route path="/chat" element={<ChatInterface />} />
              <Route path="/inbox" element={<WhatsAppInbox />} /> {/* <-- NEW ROUTE ADDED */}
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/campaigns" element={<CampaignCreator />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/receipt/:transactionId" element={<ReceiptPage />} />
            </Route>
          </Route>

          {/* --- PROTECTED ADMIN ROUTES --- */}
          {/* 🚀 CRITICAL FIX: Changed 'super_admin' to 'admin' to match the MongoDB strict enum schema */}
          <Route element={<ProtectedRoute requiredRole="admin" />}>
            <Route element={<Layout />}>
              <Route path="/admin" element={<AdminDashboard />} />
            </Route>
          </Route>

          {/* --- GLOBAL FALLBACK --- */}
          {/* Catch-all: If user is logged in, they hit dashboard; if guest, they hit landing */}
          <Route path="*" element={<Navigate to="/" replace />} />
          
        </Routes>
        
        {/* Global Toast Notifications */}
        <Toaster />
        
      </AuthProvider>
    </Router>
  );
}

export default App;